import formAPIPatientsIPDView from "./ipdpatientsview";

var formattedOutput = null;

const formapimodalpatientsipdview = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPIPatientsIPDView(item));


  return formattedOutput
};

export default formapimodalpatientsipdview